import { Chip, alpha, useTheme } from '@mui/material'

import rem from '~/utils/ui'

type TProps = {
  isTest: boolean
  statusLabel: string
}

export default function TestBadgeChip({ isTest, statusLabel }: TProps) {
  const theme = useTheme()

  if (!isTest || statusLabel === 'Test') {
    return null
  }

  return (
    <Chip
      label="Test"
      size="small"
      sx={{
        borderRadius: rem(6),
        border: `${rem(1)} solid ${alpha(theme.palette.info.dark, 0.5)}`,
        backgroundColor: alpha(theme.palette.info.dark, 0.1),
        color: theme.palette.info.dark,
        height: rem(22),
        textAlign: 'center',
      }}
    />
  )
}
